import { useMutation } from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { toast } from "@krea/shared/design-system/utils/toast";

import { useOptimisticallyUpdateLenderApplication } from "@/features/lender-applications/hooks/use-optimistically-update-lender-application";
import { mutationKeyMap } from "@/features/query-client";

import { deleteBid } from "../../api";

type ResponseType = Awaited<ReturnType<typeof deleteBid>>;

interface IDeleteBidInput {
  lenderCompanyId: number;
  lenderApplicationId: number;
  lenderResponseId: number;
}

export const useDeleteBid = () => {
  const optimisticallyUpdateLenderApplication =
    useOptimisticallyUpdateLenderApplication();

  return useMutation<ResponseType, AxiosError, IDeleteBidInput>({
    mutationFn: async ({
      lenderCompanyId,
      lenderApplicationId,
      lenderResponseId,
    }) => {
      return await deleteBid(
        lenderCompanyId,
        lenderApplicationId,
        lenderResponseId,
      );
    },
    mutationKey: mutationKeyMap.deleteBid,
    onSuccess: async (response, { lenderApplicationId }) => {
      optimisticallyUpdateLenderApplication(lenderApplicationId, response);
    },
    onError: (_error, { lenderApplicationId }) => {
      toast.error(`Failed deleting bid for application ${lenderApplicationId}`);
    },
  });
};
